import React from 'react'

export default function RecipeHeader() {
  return (
    <header className="bg-white border-b border-gray-200">
      <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
        <a href="/recipes" className="flex items-center gap-2">
          <img src="/logo.svg" alt="Koru Kids" className="h-8" />
          <span className="text-lg font-semibold text-emerald-800">Family Cookbook</span>
        </a>
      </div>
    </header>
  )
}
